<template>
  <v-container>
    <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-row>
    <v-row dense class="mt-9" v-else>
      <v-col cols="12" md="10" class="d-flex align-center">
        <v-form v-model="valid" ref="form">
          <v-card
            elevation="1"
            style="background-color: transparent"
            min-height="10vh"
            min-width="70vw"
          >
            <v-card-text>
              <v-file-input
                v-model="avatar"
                ref="fileInput"
                id="fileInput"
                hide-input
                accept="image/*"
                style="visibility: hidden"
              />
              <v-row dense>
                <v-col
                  cols="12"
                  md="3"
                  class="d-flex align-start justify-center"
                >
                  <v-avatar
                    color="primary"
                    size="200"
                    v-if="profile.avatar"
                    @click="triggerFileInput"
                    class="cursor-pointer"
                  >
                    <v-img
                      v-if="hasAvatar"
                      contain
                      :src="profile.avatar"
                      rounded
                    />
                    <span v-else class="text-h2 white--text">
                      {{ initials }}
                    </span>
                  </v-avatar>
                </v-col>
                <v-col class="d-flex flex-column justify-center">
                  <span class="primary--text text-h4">{{
                    profile.full_name
                  }}</span>
                  <strong class="text-h5 mt-2"
                    >Modalidade: <span class="text-h6">Dupla</span></strong
                  >
                  <strong class="text-h5"
                    >Frequência: <span class="text-h6">2x Semana</span></strong
                  >
                  <strong class="text-h5"
                    >Professor/Tutor: <span class="text-h6">-</span></strong
                  >
                  <strong class="text-h5"
                    >Nível:
                    <span
                      class="text-h6"
                      :class="profile.pendingInfo ? 'alert' : 'gradient'"
                      >{{ profile.englishLevel }}</span
                    >
                  </strong>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="10"
                  class="d-flex align-center justify-end"
                >
                  <v-btn
                    large
                    rounded
                    outlined
                    color="primary"
                    class="mr-3"
                    @click="returnToHome"
                  >
                    <v-img
                      contain
                      src="@/assets/icons/undo.svg"
                      class="mr-3"
                    ></v-img>
                    <span style="text-transform: none">Voltar</span>
                  </v-btn>
                  <v-btn
                    large
                    rounded
                    color="primary"
                    :loading="loadingSave"
                    @click="submit"
                  >
                    <v-img
                      contain
                      src="@/assets/icons/refresh.svg"
                      class="mr-3"
                    ></v-img>
                    <span class="white--text" style="text-transform: none"
                      >Atualizar</span
                    >
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense class="mt-8">
                <v-tabs
                  v-model="tab"
                  centered
                  icons-and-text
                  background-color="transparent"
                >
                  <v-row dense>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-1"> Dados Gerais </v-tab>
                    </v-col>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-2"> Disponibilidade </v-tab>
                    </v-col>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-3"> Plano de ensino </v-tab></v-col
                    >
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-4"> Financeiro </v-tab></v-col
                    >
                    <v-col
                      class="d-flex justify-center"
                      v-if="profile.pendingInfo"
                    >
                      <v-tab href="#tab-5">
                        <span class="pulsingText"
                          >Experiência profissional</span
                        >
                      </v-tab>
                    </v-col>
                  </v-row>
                  <v-tabs-items
                    v-model="tab"
                    style="background-color: transparent"
                  >
                    <v-tab-item value="tab-1">
                      <v-row dense class="mt-4">
                        <v-card
                          elevation="1"
                          style="background-color: transparent"
                          min-height="10vh"
                          min-width="70vw"
                        >
                          <v-card-text elevation="1">
                            <v-card
                              style="background-color: transparent"
                              elevation="1"
                            >
                              <v-card-text>
                                <v-row dense>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      v-model="profile.full_name"
                                      label="Nome"
                                      :currentValue="profile.full_name"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      v-model="profile.phone"
                                      :outlined="true"
                                      label="Telefone"
                                      :currentValue="profile.phone"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Email"
                                      v-model="profile.email"
                                      :currentValue="profile.email"
                                      :customRule="rules.email"
                                    />
                                  </v-col>
                                </v-row>
                                <v-row dense>
                                  <v-col cols="12" md="4">
                                    <custom-masked-input
                                      :outlined="true"
                                      label="CPF"
                                      :currentValue="profile.document"
                                      :customRule="rules.document"
                                      v-model="profile.document"
                                      :mask="'###.###.###-##'"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-masked-input
                                      :outlined="true"
                                      label="Data de nascimento"
                                      v-model="profile.birthDate"
                                      :currentValue="profile.birthDate"
                                      :mask="'##/##/####'"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      type="password"
                                      label="Senha"
                                      hint="Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial"
                                      :customRule="rules.optionalPwd"
                                    />
                                  </v-col>
                                </v-row>
                                <v-row dense>
                                  <v-col cols="12" md="12">
                                    <v-textarea
                                      label="Bio"
                                      placeholder="Nos fale um pouco sobre você 😁"
                                      :outlined="true"
                                      rows="4"
                                      v-model="profile.bio"
                                    />
                                  </v-col>
                                </v-row>
                                <v-row
                                  dense
                                  align="center"
                                  justify="center"
                                  v-if="profile.underAge"
                                  class="mt-4"
                                >
                                  <strong style="color: #e85526"
                                    >Responsável legal</strong
                                  >
                                </v-row>
                                <div
                                  v-if="profile.underAge"
                                  class="mt-4"
                                  style="
                                    border-style: solid;
                                    border-color: #a0a0a3;
                                    border-width: 1px;
                                    padding: 2vh;
                                    border-radius: 10px;
                                  "
                                >
                                  <v-row dense>
                                    <v-col>
                                      <custom-input
                                        v-model="profile.legalGuardian.name"
                                        :currentValue="
                                          profile.legalGuardian.name
                                        "
                                        :outlined="true"
                                        label="Nome completo"
                                      ></custom-input>
                                    </v-col>
                                    <v-col>
                                      <custom-input
                                        :outlined="true"
                                        label="Email"
                                        :customRule="rules.email"
                                        :currentValue="
                                          profile.legalGuardian.email
                                        "
                                        v-model="profile.legalGuardian.email"
                                      ></custom-input>
                                    </v-col>
                                    <v-col>
                                      <custom-masked-input
                                        label="Número de telefone do responsável"
                                        placeholder="(11)99999-9999"
                                        hint="ex:(11)1234-5678"
                                        :mask="'(##)#####-####'"
                                        :outlined="true"
                                        v-model="profile.legalGuardian.phone"
                                        :currentValue="
                                          profile.legalGuardian.phone
                                        "
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row dense>
                                    <v-col>
                                      <custom-masked-input
                                        :outlined="true"
                                        label="CPF"
                                        :mask="'###.###.###-##'"
                                        :customRule="rules.document"
                                        :currentValue="
                                          profile.legalGuardian.document
                                        "
                                        v-model="profile.legalGuardian.document"
                                      />
                                    </v-col>
                                    <v-col>
                                      <custom-masked-input
                                        :outlined="true"
                                        label="Data de nascimento"
                                        :mask="'##/##/####'"
                                        :customRule="rules.validDate"
                                        :currentValue="
                                          profile.legalGuardian.birthDate
                                        "
                                        v-model="
                                          profile.legalGuardian.birthDate
                                        "
                                      />
                                    </v-col>
                                    <v-col>
                                      <div><span>Grau de parentesco</span></div>
                                      <div
                                        class="d-flex align-center justify-center"
                                      >
                                        <v-select
                                          outlined
                                          rounded
                                          background-color="#F1F3F5"
                                          :items="parentGrades"
                                          :item-value="`value`"
                                          :item-text="`text`"
                                          v-model="
                                            profile.legalGuardian.kinship
                                          "
                                        />
                                      </div>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-card-text>
                            </v-card>

                            <v-card
                              style="background-color: transparent"
                              elevation="1"
                            >
                              <v-card-text>
                                <v-row
                                  dense
                                  align="center"
                                  justify="center"
                                  class="mt-6"
                                >
                                  <strong>Endereço</strong>
                                </v-row>

                                <v-row dense class="mt-4">
                                  <v-col cols="12" md="4">
                                    <debounced-input
                                      :outlined="true"
                                      ref="zipCodeInput"
                                      label="CEP"
                                      placeholder="12345678"
                                      hint="Apenas números"
                                      v-model="profile.address.zipCode"
                                      :currentValue="profile.address.zipCode"
                                      @search="getAddressByZipCode"
                                    ></debounced-input>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      ref="streetInput"
                                      :outlined="true"
                                      label="Logradouro"
                                      :currentValue="profile.address.street"
                                      v-model="profile.address.street"
                                      :placeholder="
                                        loadingAddress
                                          ? 'Carregando...'
                                          : 'Nome da rua'
                                      "
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Número"
                                      :currentValue="profile.address.number"
                                      v-model="profile.address.number"
                                    />
                                  </v-col>
                                </v-row>
                                <v-row dense>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Complemento"
                                      :currentValue="profile.address.complement"
                                      v-model="profile.address.complement"
                                      :required="false"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      ref="neighboorhoodInput"
                                      label="Bairro"
                                      :currentValue="
                                        profile.address.neighboorhood
                                      "
                                      v-model="profile.address.neighboorhood"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Cidade"
                                      ref="cityInput"
                                      :currentValue="profile.address.province"
                                      v-model="profile.address.province"
                                    />
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-row dense class="mt-4">
                        <v-card
                          elevation="0"
                          style="background-color: transparent"
                          min-height="10vh"
                          min-width="70vw"
                        >
                          <v-card-text>
                            <v-row dense align="center" justify="center">
                              <span>Horários</span>
                            </v-row>
                            <v-row
                              dense
                              v-for="(available, index) in profile.aviability"
                              :key="index"
                              align="center"
                            >
                              <v-col cols="12" md="4">
                                <div>Dia da semana</div>
                                <v-select
                                  v-model="available.weekDay"
                                  :items="weekDaysItems"
                                  :item-text="`text`"
                                  :item-value="`value`"
                                  outlined
                                  :disabled="!available.editable"
                                />
                              </v-col>
                              <v-col cols="12" md="3">
                                <div>Início</div>
                                <v-select
                                  v-model="available.from"
                                  outlined
                                  :items="hoursItemsHalf"
                                  :disabled="!available.editable"
                                  @change="updateEnd(available)"
                                />
                              </v-col>
                              <v-col cols="12" md="3">
                                <div>Fim</div>
                                <v-select
                                  v-model="available.to"
                                  outlined
                                  :items="hoursItemsHalf"
                                  :disabled="!available.editable"
                                />
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-btn
                                  icon
                                  @click="
                                    removerDisponibilidade(available.id, index)
                                  "
                                  :disabled="!available.editable"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row align="center" justify="center">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    circle
                                    icon
                                    v-on="on"
                                    v-bind="attrs"
                                    @click="inserirHorario"
                                    ><v-icon>mdi-plus</v-icon></v-btn
                                  >
                                </template>
                                <span>Adicionar horário</span>
                              </v-tooltip>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                      <v-row dense>
                        <v-col cols="12" md="4">
                          <v-card
                            elevation="0"
                            style="background-color: transparent"
                            min-height="10vh"
                            min-width="70vw"
                          >
                            <v-card-text>
                              <v-row dense class="mt-9">
                                <v-col cols="12" md="6">
                                  <span
                                    class="text-h5"
                                    style="font-weight: bold"
                                    >Estude do seu jeito, no seu tempo</span
                                  ></v-col
                                >
                                <v-col cols="12" md="2">
                                  <v-select
                                    label="Nível"
                                    rounded
                                    outlined
                                    :items="englishLevels"
                                    :item-value="`value`"
                                    :item-text="`text`"
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" md="2">
                                  <v-select
                                    label="Modalidade"
                                    rounded
                                    outlined
                                    :items="types"
                                    :item-value="`value`"
                                    :item-text="`text`"
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" md="2">
                                  <v-select
                                    label="Tempo"
                                    rounded
                                    outlined
                                    :items="times"
                                    :item-value="`value`"
                                    :item-text="`text`"
                                  ></v-select>
                                </v-col>
                              </v-row>
                              <v-row dense class="mt-2">
                                <v-col cols="12" md="3">
                                  <v-img
                                    height="50vh"
                                    width="40vw"
                                    contain
                                    src="@/assets/images/connect/booster.webp"
                                  />
                                </v-col>
                                <v-col cols="12" md="9">
                                  <v-row dense>
                                    <v-card
                                      elevation="0"
                                      style="background-color: transparent"
                                      min-height="10vh"
                                      min-width="70vw"
                                    >
                                      <v-card-text>
                                        <v-row dense>
                                          <v-col
                                            cols="12"
                                            md="9"
                                            class="d-flex align-center justify-center"
                                          >
                                            <span class="text-h6"
                                              >Em quanto tempo planeja terminar
                                              o curso ?</span
                                            >
                                          </v-col>
                                        </v-row>
                                        <v-row dense class="mt-4">
                                          <v-col
                                            cols="12"
                                            md="3"
                                            class="d-flex align-center justify-center"
                                          >
                                            <v-card
                                              color="transparent"
                                              width="25vh"
                                              elevation="0"
                                            >
                                              <v-toolbar
                                                elevation="0"
                                                style="
                                                  height: 1vh;
                                                  background-color: #a0a0a3;
                                                "
                                              ></v-toolbar>

                                              <v-card-text>
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h7"
                                                    >Seu plano</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h4"
                                                    >5</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h7"
                                                    >Anos</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h6"
                                                    >R$ 120/Mês</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <v-btn
                                                    rounded
                                                    outlined
                                                    disabled
                                                  >
                                                    <span
                                                      class="text-h7"
                                                      style="
                                                        text-transform: none;
                                                      "
                                                      >Atual</span
                                                    >
                                                  </v-btn></v-row
                                                >
                                              </v-card-text>
                                            </v-card>
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="3"
                                            class="d-flex align-center justify-center"
                                          >
                                            <v-card
                                              color="transparent"
                                              width="25vh"
                                              elevation="0"
                                            >
                                              <v-toolbar
                                                elevation="0"
                                                class="primary-600"
                                                style="height: 1vh"
                                              ></v-toolbar>

                                              <v-card-text>
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span
                                                    class="text-h7"
                                                    style="color: #e8276f"
                                                    >Booster</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span
                                                    class="text-h4"
                                                    style="color: #e8276f"
                                                    >3</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span
                                                    class="text-h7"
                                                    style="color: #e8276f"
                                                    >Anos</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span
                                                    class="text-h6"
                                                    style="color: #e8276f"
                                                    >R$ 160/Mês</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <v-btn
                                                    rounded
                                                    color="primary"
                                                  >
                                                    <span
                                                      class="text-h7"
                                                      style="
                                                        text-transform: none;
                                                      "
                                                      >Escolher</span
                                                    >
                                                  </v-btn></v-row
                                                >
                                              </v-card-text>
                                            </v-card></v-col
                                          >
                                          <v-col
                                            cols="12"
                                            md="3"
                                            class="d-flex align-center justify-center"
                                          >
                                            <v-card
                                              color="transparent"
                                              width="25vh"
                                              elevation="0"
                                            >
                                              <v-toolbar
                                                elevation="0"
                                                style="
                                                  height: 1vh;
                                                  background-color: #a0a0a3;
                                                "
                                              ></v-toolbar>

                                              <v-card-text>
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h7"
                                                    >Booster</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h4"
                                                    >1</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h7"
                                                    >Ano</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h6"
                                                    >R$ 220/Mês</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <v-btn rounded outlined>
                                                    <span
                                                      class="text-h7"
                                                      style="
                                                        text-transform: none;
                                                      "
                                                      >Escolher</span
                                                    >
                                                  </v-btn></v-row
                                                >
                                              </v-card-text>
                                            </v-card></v-col
                                          >
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="12" md="2"></v-col>
                                          <v-col
                                            cols="12"
                                            md="5"
                                            class="d-flex align-center justify-center"
                                          >
                                            <span class="text-h7"
                                              >Para mais informações, consulte
                                              nossos
                                              <a
                                                >Termos de Uso e Política de
                                                Privacidade.</a
                                              >
                                              Estamos à disposição para
                                              esclarecer qualquer dúvida.
                                              😊</span
                                            >
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="12" md="2"></v-col>
                                          <v-col
                                            cols="12"
                                            md="5"
                                            class="d-flex align-center justify-center"
                                            ><v-btn
                                              rounded
                                              outlined
                                              style="text-transform: none"
                                              class="primary-600 white--text"
                                              >Turbinar</v-btn
                                            ></v-col
                                          >
                                        </v-row>
                                      </v-card-text>
                                    </v-card>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-4">
                      <v-row dense align="center">
                        <v-col
                          cols="12"
                          md="6"
                          v-for="(card, index) in cards"
                          :key="index"
                        >
                          <Card :data="card" />
                        </v-col>
                        <v-col cols="12" md="5">
                          <div
                            class="addCard d-flex align-center justify-center"
                            style="min-height: 30vh"
                          >
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  plain
                                  v-on="on"
                                  v-bind="attrs"
                                  icon
                                  @click="openCheckout"
                                >
                                  <v-img
                                    contain
                                    width="10vw"
                                    height="10vh"
                                    src="@/assets/icons/card.svg"
                                  />
                                </v-btn>
                              </template>
                              <span>Adicionar cartão de crédito</span>
                            </v-tooltip>
                          </div>
                          <CheckoutDialog ref="checkout" /> </v-col></v-row
                    ></v-tab-item>
                    <v-tab-item value="tab-5">
                      <v-card style="background-color: transparent">
                        <v-card-text>
                          <v-row dense>
                            <v-row dense class="mt-4">
                              <v-col
                                cols="12"
                                md="12"
                                class="d-flex flex-column"
                              >
                                <strong class="mt-1"
                                  >Qual o seu objetivo?</strong
                                >
                                <v-radio-group
                                  row
                                  v-model="profile.details.mainGoal"
                                  :rules="rules.required"
                                >
                                  <v-radio
                                    label="Profissional"
                                    :value="1"
                                  ></v-radio>
                                  <v-radio
                                    label="Comunicação"
                                    :value="2"
                                  ></v-radio>
                                  <v-radio label="Viagens" :value="3"></v-radio>
                                  <v-radio label="Outros" :value="4"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider
                              ></v-col>
                              <v-col
                                cols="12"
                                md="12"
                                class="d-flex flex-column mt-6"
                              >
                                <strong class="mt-1"
                                  >Como prefere estudar ?</strong
                                >
                                <v-radio-group
                                  v-model="profile.details.preference"
                                  :rules="rules.required"
                                  row
                                >
                                  <v-radio label="Sozinho" :value="1"></v-radio>
                                  <v-radio
                                    label="Com Professor"
                                    :value="2"
                                  ></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col
                                cols="12"
                                md="12"
                                class="d-flex flex-column mt-6"
                              >
                                <strong class="mt-1"
                                  >Quantas aulas por semana gostaria de ter
                                  ?</strong
                                >
                                <v-radio-group
                                  v-model="profile.details.perWeek"
                                  :rules="rules.required"
                                  row
                                >
                                  <v-radio label="1" :value="1"></v-radio>
                                  <v-radio label="2" :value="2"></v-radio>
                                  <v-radio label="3+" :value="3"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col
                                cols="12"
                                md="12"
                                class="d-flex flex-column mt-6"
                              >
                                <strong class="mt-1">
                                  Quantas horas por dia de estudo?</strong
                                >
                                <v-radio-group
                                  v-model="profile.details.availableHours"
                                  row
                                  :rules="rules.required"
                                >
                                  <v-radio label="1:00" :value="1"></v-radio>

                                  <v-radio label="1:30" :value="2"></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>

                              <v-col
                                cols="12"
                                md="12"
                                class="d-flex flex-column mt-6"
                              >
                                <strong class="mt-1"
                                  >Em qual modalidade deseja estudar?</strong
                                >
                                <v-radio-group
                                  row
                                  v-model="profile.details.formatGoal"
                                  :rules="rules.required"
                                >
                                  <v-radio
                                    v-for="(goal, index) in types"
                                    :key="index"
                                    :label="goal.text"
                                    :value="goal.value"
                                  ></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" md="12" class="mt-6">
                                <strong class="mt-1"
                                  >Onde você costuma estudar inglês?</strong
                                >

                                <v-row dense class="mt-2">
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(learningWay, index) in learningWays"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      v-model="profile.details.mainContacts"
                                      :value="learningWay"
                                      :label="learningWay"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col
                                cols="12"
                                md="12"
                                class="d-flex flex-column mt-6"
                              >
                                <strong class="mt-1"
                                  >Qual é a sua área de atuação
                                  atualmente?</strong
                                >
                                <v-row dense>
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(area, index) in currentAreas"
                                    class="d-flex align-center justify-start"
                                    :key="index"
                                  >
                                    <v-checkbox
                                      v-model="profile.details.currentAreas"
                                      :value="area"
                                      :label="area"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>

                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" md="12" class="mt-6">
                                <strong class="mt-1"
                                  >De 0 a 10 o quando vc classifica sua
                                  habilidade para assistir filmes ou séries em
                                  inglês com legenda</strong
                                >

                                <v-radio-group
                                  row
                                  v-model="profile.details.skills.watchWithSub"
                                  :rules="rules.required"
                                >
                                  <v-radio
                                    v-for="i in 11"
                                    :key="i"
                                    :value="i"
                                    :label="(i - 1).toString()"
                                  ></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" md="12" class="mt-6">
                                <strong
                                  >Assistir filmes ou séries em inglês sem
                                  legenda
                                </strong>
                                <v-radio-group
                                  row
                                  v-model="
                                    profile.details.skills.watchWithoutSub
                                  "
                                  :rules="rules.required"
                                >
                                  <v-radio
                                    v-for="i in 11"
                                    :key="i"
                                    :value="i"
                                    :label="(i - 1).toString()"
                                  ></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" md="12" class="mt-6">
                                <strong>Entender uma conversa em inglês</strong>
                                <v-radio-group
                                  row
                                  v-model="profile.details.skills.understanding"
                                  :rules="rules.required"
                                >
                                  <v-radio
                                    v-for="i in 11"
                                    :key="i"
                                    :value="i"
                                    :label="(i - 1).toString()"
                                  ></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" md="12" class="mt-6">
                                <strong
                                  >Se comunicar em uma conversa em
                                  inglês</strong
                                >
                                <v-radio-group
                                  row
                                  v-model="profile.details.skills.communication"
                                  :rules="rules.required"
                                >
                                  <v-radio
                                    v-for="i in 11"
                                    :key="i"
                                    :value="i"
                                    :label="(i - 1).toString()"
                                  ></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" md="12" class="mt-6">
                                <strong
                                  >Ler um livro ou artigo em inglês</strong
                                >
                                <v-radio-group
                                  row
                                  v-model="profile.details.skills.reading"
                                  :rules="rules.required"
                                >
                                  <v-radio
                                    v-for="i in 11"
                                    :key="i"
                                    :value="i"
                                    :label="(i - 1).toString()"
                                  ></v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { cpf } from "cpf-cnpj-validator";
import addressAPI from "@/shared/addressApi";
import Card from "@/components/checkout/Card.vue";
import customerApi from "@/shared/pitchCustomerApi";
import { isBefore, isValid, parse, differenceInYears } from "date-fns";
import CheckoutDialog from "@/components/checkout/CheckoutDialog.vue";
import { mapActions } from "vuex";
export default {
  name: "CustomerProfile",
  components: {
    Card,
    CheckoutDialog,
  },
  mixins: [],
  props: {},
  computed: {
    initials() {
      return localStorage.getItem("initials");
    },
  },
  data() {
    return {
      loading: true,
      loadingSave: false,
      loadingAddress: false,
      valid: false,
      tab: null,
      hasAvatar: false,
      avatar: null,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      profile: {
        name: "",
        phone: "",
        email: "",
        document: "",
        birthDate: "",
        password: "",
        details: {
          skills: {},
          mainContacts: [],
          currentAreas: [],
        },
        address: {
          street: "",
          number: "",
          complement: "",
          neighboorhood: "",
          province: "",
          zipCode: "",
        },
        aviability: [],
      },
      rules: {
        validDate: [(v) => this.validDate(v) || "Data de nascimento inválida."],
        document: [
          (v) => this.validateDocNumber(v) || "Número de documento inválido.",
        ],
        email: [
          (v) => !!v || "Campo obrigatório.",
          (v) => /.+@.+\..+/.test(v) || "Email inválido.",
        ],
        optionalPwd: [
          (v) =>
            this.testPWD(v) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
        password: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
              v
            ) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
        required: [(v) => !!v || "Selecione uma opção."],
      },
      cards: [
        {
          current: true,
          name: "NuPagamentos",
          holder: "Sophia Braga",
          maskedNumber: "**** **** **** 1234",
          cvv: "**1",
          expMonth: "02",
          expYear: "2027",
        },
      ],
      englishLevels: [
        {
          text: "Beginner 1",
          value: "beginner_1",
        },
        {
          text: "Beginner 2",
          value: "beginner_2",
        },
        {
          text: "Essential 1",
          value: "essential_1",
        },
        {
          text: "Essential 2",
          value: "essential_2",
        },
        {
          text: "Pre-Intermediate 1",
          value: "pre_intermediate_1",
        },
        {
          text: "Pre-Intermediate 2",
          value: "pre_intermediate_2",
        },
        {
          text: "Intermediate 1",
          value: "intermediate_1",
        },
        {
          text: "Intermediate 2",
          value: "intermediate_2",
        },
        {
          text: "Upper 1",
          value: "upper_1",
        },
        {
          text: "Upper 2",
          value: "upper_2",
        },
        {
          text: "Advanced 1",
          value: "Advanced_1",
        },
        {
          text: "Advanced 2",
          value: "advanced_2",
        },
      ],
      types: [
        {
          text: "Conversation",
          value: "ALONE",
        },
        {
          text: "Dupla",
          value: "DUO",
        },
        {
          text: "Trio",
          value: "TRIO",
        },
        {
          text: "Quarteto",
          value: "SQUAD",
        },
      ],
      times: [
        {
          text: "1:00",
          value: "1h",
        },
        {
          text: "1:30",
          value: "1:30h",
        },
      ],
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
      parentGrades: [
        { text: "Pai/Mãe", value: 1 },
        { text: "Padrasto/Madrasta", value: 2 },
        { text: "Tio/Tia", value: 3 },
        { text: "Avô/Avó", value: 4 },
        { text: "Responsável legal", value: 5 },
        { text: "Outro", value: 6 },
      ],
      learningWays: [
        "Música",
        "Filmes e Séries",
        "Livros",
        "Estudos",
        "Trabalho",
        "Outras Formas",
        "Amigos",
        "Redes Sociais",
      ],
      currentAreas: [
        "Estudante",
        "Educação",
        "Comércio",
        "Tecnologia",
        "Saúde",
        "Outros",
      ],
      hoursItemsHalf: [
        "06:00",
        "06:30",
        "07:00",
        "07:30",
        "08:00",
        "08:30",
        "09:00",
        "09:30",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
        "20:00",
        "20:30",
        "21:00",
        "21:30",
        "22:00",
      ],
    };
  },
  watch: {
    "profile.birthDate": {
      handler: function (value) {
        if (value) {
          try {
            const birthDate = parse(value, "dd/MM/yyyy", new Date());

            const difference = differenceInYears(new Date(), birthDate);
            if (difference < 18) {
              this.profile.underAge = true;
            } else {
              this.profile.underAge = false;
            }
          } catch (e) {
            return e;
          }
        }
      },
      deep: true,
    },
    avatar: function (value) {
      if (value) {
        this.profile.avatar = URL.createObjectURL(value);
        this.hasAvatar = true;
      }
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(["setAvatar"]),
    loadData() {
      customerApi.showProfile().then((res) => {
        this.profile = Object.assign({}, res.data);
        this.profile.details = {
          skills: {},
          mainContacts: [],
          currentAreas: [],
        };
        this.loading = false;
        try {
          new URL(res.data.avatar);
          this.hasAvatar = true;
        } catch {
          this.hasAvatar = false;
        }
      });
    },
    testPWD(value) {
      if (!value) return true;
      return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
        value
      );
    },
    openCheckout() {
      this.$refs.checkout.open();
    },
    validateDocNumber(doc) {
      return cpf.isValid(doc);
    },
    validDate(d) {
      const inputedDate = parse(d, "dd/MM/yyyy", new Date());
      return isValid(inputedDate) && isBefore(inputedDate, new Date());
    },
    returnToHome() {
      this.$router.push({
        path: "cockpit",
      });
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.loadingSave = true;
        if (this.avatar) {
          const formData = new FormData();
          formData.append("avatar", this.avatar);
          await customerApi
            .uploadFiles(formData)
            .then((res) => {
              this.profile.avatar = res.data.ok;
              this.setAvatar(res.data.ok);
            })
            .finally(() => {});
        }
        if (this.profile.pendingInfo) {
          this.profile.details = {
            ...this.profile.details,
            ...this.profile.details.skills,
          };
        }

        customerApi
          .updateProfile(this.profile)
          .then(() => {
            this.$root.$emit("display-alert", {
              text: "Perfil atualizado com sucesso!",
              type: 0,
            });
            this.loadData();
          })
          .catch((err) => {
            this.$root.$emit("display-alert", {
              text: `Corrija os seguintes erros ${err.data.message}`,
              type: 1,
            });
          })
          .finally(() => {
            this.loadingSave = false;
          });
      } else {
        this.$root.$emit("display-alert", {
          text: `Por favor preencha todos os campos obrigatórios!`,
          type: 1,
        });
      }
    },
    getAddressByZipCode() {
      if (this.profile.address.zipCode) {
        addressAPI
          .getAddresByZipCode(this.profile.address.zipCode)
          .then(async (res) => {
            this.$refs.streetInput.handleInput(res.data.address);
            this.$refs.neighboorhoodInput.handleInput(res.data.district);
            this.$refs.cityInput.handleInput(
              res.data.city + ` - ${res.data.state}`
            );
            this.readOnly = false;
            this.loadingAddress = false;
          })
          .catch(() => {
            this.loadingAddress = false;
            this.readOnly = false;
          });
      }
    },
    triggerFileInput() {
      document.getElementById("fileInput").click();
    },
    updateEnd(av) {
      if (!av.from || !this.profile.perClass) return;

      const [h, m] = av.from.split(":").map(Number);
      const d = new Date(2000, 0, 1, h, m);
      d.setMinutes(d.getMinutes() + this.profile.perClass);

      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");

      const result = `${hh}:${mm}`;
      av.to = this.hoursItemsHalf.includes(result) ? result : null;
    },
    async removerDisponibilidade(id, index) {
      if (id) {
        await customerApi
          .removerDisponibilidade(id)
          .then(() => {
            this.$root.$emit("display-alert", {
              text: "Disponibilidade atualizada com sucesso!",
              type: 0,
            });
            this.loadData();
          })
          .catch(() => {
            this.$root.$emit("display-alert", {
              text: `Ocorreu um pequenino problema ao atualizar sua disponibilidade, tente novamente mais tarde!`,
              type: 1,
            });
          });
      } else {
        this.profile.aviability.splice(index, 1);
      }
    },
    async inserirHorario() {
      this.profile.aviability.push({
        weekDay: null,
        from: null,
        to: null,
        editable: true,
      });
    },
  },
};
</script>
<style scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.image-col {
  position: relative;
}

.overflow-image {
  position: absolute;
  top: -17.5vh;
  right: 0;
}

.normal {
  text-transform: none;
}

.gradient {
  background: -webkit-linear-gradient(#ff9dc2, #e8276f);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.pulsingText {
  color: #ff5d2a;
  animation: pulse 2s infinite;
  border-radius: 30%;
  padding: 1vh;
}

.alert {
  color: #e85526;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(144, 0, 222, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 1rem rgba(144, 0, 222, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(144, 0, 222, 0);
  }
}
</style>
